import { watermarkService } from "app/common/services/watermarkService";

export default () => {
    return {
        chart: {
            events: {
                load: function () {
                    // @ts-ignore FIXME: strict migration - Type '{ load: () => void; }' is missing properties from type 'HCChart' — 'this' is the Highcharts chart at runtime; typing it requires Highcharts internals
                    watermarkService.add.call(this, { opacity: 0.1 });
                },
            },
        },
    };
};
